import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = {
  key: 0,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Nom et Prénom "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Téléphone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Rôle "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Service "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Sexe "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "Date création"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, "Actions")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_19 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-compare lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_33 = { key: 3 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_38 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
          to: "/ajouter-user"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Ajouter un utilisateur ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un utilisateur"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_6
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.users.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(user.nom) + " " + _toDisplayString(user.prenom), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(user.telephone), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(user.email), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(user?.userRoles[0]?.role.nom), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(user?.service?.libelle), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(user.sexe), 1),
                    _createElementVNode("td", _hoisted_17, [
                      (user.etat =='Actif')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(user.etat), 1))
                        : _createCommentVNode("", true),
                      (user.etat =='Inactif')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(user.etat), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.format_date(user.createdAt)), 1),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("ul", _hoisted_24, [
                          (_ctx.checkPermission('AssignAgenceUser'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "#",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#EditUserAgenceModal",
                                  onClick: ($event: any) => (_ctx.openEditAgenceModal(user))
                                }, [
                                  _hoisted_27,
                                  _createTextVNode(" Affecter une agence ")
                                ], 8, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('EditPasswordUser'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "#",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#EditUserPassModal",
                                  onClick: ($event: any) => (_ctx.openEditPassModal(user))
                                }, [
                                  _hoisted_30,
                                  _createTextVNode(" Modifier le mot de passe ")
                                ], 8, _hoisted_29)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('EditUser'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                _createVNode(_component_router_link, {
                                  class: "dropdown-item d-flex align-items-center",
                                  to: { name: 'EditUserPage',params: { id: user.id } }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_32,
                                    _createTextVNode(" Modifier les informations ")
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.checkPermission('DeleteUser'))
                            ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                                (user.etat == 'Actif')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.desactiver(user))
                                    }, [
                                      _hoisted_35,
                                      _createTextVNode(" Désactiver ")
                                    ], 8, _hoisted_34))
                                  : _createCommentVNode("", true),
                                (user.etat == 'Inactif')
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.desactiver(user))
                                    }, [
                                      _hoisted_37,
                                      _createTextVNode(" Activer ")
                                    ], 8, _hoisted_36))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}